import { useTranslation } from "react-i18next";
import "./Footer.scss";
import packageJson from "../../../package.json";
import HeaderLogo from "../../utils/Images/HeaderLogo";
import { getCurrentYear } from "../../utils/Common/Constant";
const Footer = () => {
  const { t } = useTranslation();
  return (
    <div className="footer">
      <div className="logo">
        <HeaderLogo />
      </div>
      <div className="middle">
        <p>
          © {getCurrentYear()}, Evluate Global,&nbsp;Inc.&nbsp;| &nbsp;
          {t("GENERAL.VERSION")}:{packageJson.version}
        </p>
      </div>

      <div className="base">
        <button className="getSupport"> {t("GET_SUPPORT")}</button>
        <button className="reportBug"> {t("REPORT_BUG")}</button>
      </div>
    </div>
  );
};

export default Footer;
